var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23C13.125 23 25 16.6114 25 7.66721C25 3.19516 21.875 0.0562874 18.125 0.000822303C16.25 -0.0269102 14.375 0.638965 12.5 3.19451C10.625 0.638965 8.71756 0.000821358 6.875 0.000821358C3.125 0.000821358 0 3.19516 0 7.66721C0 16.6114 11.875 23 12.5 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.031cb4f325ee9fc431310ba3ba319c44.svg";
export { ForwardRef as ReactComponent };